import { useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { brazilianDateMask } from 'utils/masks'
import { validateDate } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueDate({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidateDate = (date: string): boolean => {
    let initialValue = { isValid: true, message: '' }

    if (date && !validateDate(date)) {
      initialValue = { isValid: false, message: 'Data está errada' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <MaskedInput
          mask={brazilianDateMask}
          {...formMethods.register('default_value', { validate: handleValidateDate })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
